import { useEffect, useState } from "react";
import { Form, Button, Spin } from "antd";
import { CloseOutlined, LoadingOutlined } from "@ant-design/icons";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { getEnageUser } from "../../../global/hooks/getUserRole";
import usePostEngageLogin from "../../../global/hooks/usePostEngageLogin";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";

export const EngageModalForm = ({
  type,
  setEngageModalForm,
  fetchData,
  defaultValue,
  setDefaultValue,
  infoForm,
}) => {
  const [form] = Form.useForm();

  const postUrl = `${process.env.REACT_APP_API_URL}/api/engage/register-site`;
  const putUrl = `${process.env.REACT_APP_API_URL}/api/engage/update-site`;
  const user = getEnageUser();
  const {
    data: postData,
    loading: postLoading,
    error: postError,
    postData: postAction,
  } = usePostEngageLogin(postUrl);
  const {
    data: putData,
    loading: putLoading,
    error: putError,
    postData: putAction,
  } = usePostEngageLogin(putUrl);

  useEffect(() => {
    if (type === "Add") {
      if (postError) {
        openErrorNotification(
          postError?.response?.data?.message || "Something went wrong"
        );
      } else if (!postLoading && !postError && postData) {
        // showToast(postData?.message, "success", faCheckCircle);
        setEngageModalForm(false);
        openConfirmNotification("Success");
        fetchData && fetchData();
        form.resetFields();
      }
    }
    if (type === "Edit") {
      if (putError) {
        openErrorNotification(
          putError?.response?.data?.message || "Something went wrong"
        );
      } else if (!putLoading && !putError && putData) {
        // showToast(putData?.message, "success", faCheckCircle);
        setDefaultValue &&
          setDefaultValue({
            SiteName: putData?.data?.data?.Name,
            SiteReference: putData?.data?.data?.SiteReference,
          });
        setDefaultValue &&
          localStorage.setItem(
            "engageSiteData",
            JSON.stringify({
              SiteReference: putData?.data?.data?.SiteReference,
              SiteName: putData?.data?.data?.Name,
            })
          );
        infoForm &&
          infoForm.setFieldsValue({
            SiteName: putData?.data?.data?.Name,
            SiteReference: putData?.data?.data?.SiteReference,
          });
        setEngageModalForm(false);
        openConfirmNotification("Success");
        fetchData && fetchData();
        form.resetFields();
      }
    }
  }, [putError, putError, putLoading, putData, postError, postLoading]);

  useEffect(() => {
    if (defaultValue) {
      form.setFieldsValue({
        SiteName: defaultValue?.SiteName,
      });
    } else {
      form.resetFields();
    }
  }, [defaultValue]);

  const handleSubmit = async (values) => {
    const body = {
      ...values,
      UserName: user?.username,
      PassWord: user?.password,
    };
    await postAction(body);
  };

  const handleEdit = async (values) => {
    const body = {
      UserName: user?.username,
      PassWord: user?.password,
      SiteReference: defaultValue?.SiteReference,
      SiteName: values?.SiteName || defaultValue?.SiteName,
    };
    await putAction(body);
  };

  return (
    <>
      <Form
        validateTrigger={"onChange"}
        form={form}
        onFinish={null}
        scrollToFirstError
        layout={"vertical"}
        autoComplete={"off"}
      >
        <div className={`bg-white overflow-hidden`}>
          <div className="px-2 pt-1 pb-3">
            <CustomInput
              label="Name"
              name="SiteName"
              disabled={type === "info"}
              required
            />
          </div>
        </div>
      </Form>

      <div className="flex justify-center space-x-2 mt-2.5">
        <Button
          type="primary"
          className="mr-2 min-w-[104px] h-[30px] py-1 px-[10px] font-medium flex items-center "
          onClick={() => {
            form.validateFields().then((values) => {
              type === "Edit" ? handleEdit(values) : handleSubmit(values);
            });
          }}
        >
          {postLoading || putLoading ? (
            <Spin
              indicator={
                <LoadingOutlined
                  spin
                  className="h-4 w-4"
                  style={{ color: "white" }}
                />
              }
            />
          ) : (
            <div className="flex items-center gap-1">
              <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
              <span className="">Apply</span>
            </div>
          )}
        </Button>
        <Button
          className="reset-button"
          onClick={() => setEngageModalForm(false)}
        >
          <CloseOutlined />
          <span className="">Cancel</span>
        </Button>
      </div>
    </>
  );
};

export default EngageModalForm;
